import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { getApiKeys, createApiKey, updateApiKey, deleteApiKey } from "@/lib/api/api-keys";
import type { ApiKeyCreateRequest, ApiKeyUpdateRequest } from "@/types/api-key";

export const useApiKeysQuery = () =>
  useQuery({
    queryKey: ["apiKeys"],
    queryFn: () => getApiKeys(),
  });

export const useDeactivatedApiKeysQuery = () =>
  useQuery({
    queryKey: ["apiKeys", "deactivated"],
    queryFn: () => getApiKeys({ deactivated: true }),
  });

export const useCreateApiKeyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ApiKeyCreateRequest) => createApiKey(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["apiKeys"] });
    },
  });
};

export const useUpdateApiKeyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: ApiKeyUpdateRequest }) =>
      updateApiKey(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["apiKeys"] });
    },
  });
};

export const useDeleteApiKeyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteApiKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["apiKeys"] });
    },
  });
};
